import * as React from 'react';
import { PrimaryButton, DefaultButton } from '@magoosh/lib/button';
import fetch from 'utilities/fetch';
import { paths } from 'config/path_helpers';
import cx from 'classnames';
import style from './style.module.scss';
import { FontAwesomeIcon } from '@magoosh/lib/icons';

interface MarkingButtonProps {
  finished: boolean;
  lessonId: number;
  authenticityToken: string;
}

// A component for a student to manually toggle whether or not they are finished with a lesson.
export default class MarkingButton extends React.Component<MarkingButtonProps> {
  state = {
    submitting: false,
    finished: this.props.finished
  };

  render() {
    const bsClass = this.state.finished ? 'btn btn-primary-outline' : 'btn btn-primary';
    return (
      <div className={cx(style.buttonContainer, style.flex)}>
        <PrimaryButton submitting={this.state.submitting} onClick={this.handleClick} bsClass={bsClass}>
          {this.state.finished ? (
            <React.Fragment>
              <FontAwesomeIcon icon={'check'} /> Lesson Finished!
            </React.Fragment>
          ) : (
            'Mark this Lesson as Finished'
          )}
        </PrimaryButton>
      </div>
    );
  }

  handleClick = () => {
    this.setState({ submitting: true }, () => {
      fetch(paths.lessonMarking(this.props.lessonId), {
        method: this.state.finished ? 'DELETE' : 'POST',
        body: JSON.stringify({
          authenticityToken: this.props.authenticityToken,
          marking: {
            name: 'completed'
          }
        })
      }).then(() => {
        this.setState({ submitting: false, finished: !this.state.finished });
      });
    });
  };
}
